export const limitsChange = {
    temporaryValidUntil: true,
    allowZeroLimits: true,
    enforceZeroPrecision: true,
    showRemovingTmpLimitsMessage: true,
};
